module.exports = __webpack_public_path__ + "img/100-receitas.3b881a00.png";